import{a as r}from"./chunk-W2XLZW4Y.mjs";import{b as t}from"./chunk-BZMO6Q6L.mjs";var o=class extends r{toString(){let i=this.toUint8Array();return t.fromHexInput(i).toString()}};export{o as a};
//# sourceMappingURL=chunk-CUWAGKEP.mjs.map